import React, { useState, useEffect } from 'react'
import "./Style.css"
import { Link, useNavigate } from 'react-router-dom'
import { Authme, Dashboard, getEarnings, getHospitalDashboard } from '../Utils/utils'
import Loader from '../../Component/Loader/Loader'
import moment from 'moment'
import Userprofile from '../../Component/Userprofile/Userprofile'
import { connect } from 'react-redux'
import { FaPhone, FaPhoneAlt, FaWhatsapp } from 'react-icons/fa'


const Booking = (props) => {
  const [loading, setLoading] = useState(false);
  const [dashboard, setDashboardData] = useState(null)
  const message = "Hi, I am your service provider.";
  const [surveyData, setSurveyData] = useState('');
  const navigate = useNavigate()
  const [finalEarn, setFinalEarn] = useState('');

  const handleDashboard = async () => {
    let token = localStorage.getItem("token");
    try {
      const response = await Dashboard(token);

      setDashboardData(response.data?.data || response.data || null);
      // console.log(response,"booking response....")
    } catch (error) {
      console.log(error, "........")
      // console.error("Error during Dashboard request:", error);
    }
  };

  const fetchData = async () => {
    setLoading(true);
    try {
      var res = await Authme();
      await handleDashboard();
    } catch (error) {
      console.error("Error during fetching data:", error);
    }
    finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleWhatsAppClick = (phone_number) => {
    const url = `https://wa.me/${phone_number}?text=${encodeURIComponent(message)}`;
    window.open(url, "_blank");
  };



  return (
    <>
      {loading && <Loader />}
      <div className="booking-top">
        <div className='booking-wrapper mx-auto'>
          <div className='booking-top-container p-4 d-flex justify-content-between'>
            <Userprofile />
          </div>

          <div className='booking-details-info p-3'>
            {/* Booking today */}
            <div className='booking-today-info bg-white'>
              <div className='row w-100 m-auto' style={{ justifyContent: 'space-between' }}>
                <div className='col-4'>
                  <span className='title'>Bookings</span>
                </div>
                {/* {props?.userdata?.role == 'channel_provider' &&
                  <div className='col-3'>
                    <button className="continue-btn-res-2 " style={{ width: '100%', height: '40px' }} type="submit" onClick={() => navigate(`/earnings`)}>
                      <span className="continuebtn-text-2" >Earnings</span>
                    </button>
                  </div>
                } */}

              </div>
              {props?.userdata?.role == 'channel_provider' &&
                <>
                  <div className='row mt-4'>
                    <div className='title w-auto'>Earnings</div>
                  </div>
                  <div className='earn-dash mt-3'>
                    <div className='col-7'>

                      <div className='head-earn'>Total Earnings</div>
                      <div className='head-num'>₹ {finalEarn}</div>
                    </div>
                    <div className='col-5'>

                      <button className="continue-btn-res-2 " style={{ width: '100%', height: '40px' }} type="submit"
                        onClick={() => navigate(`/earnings`)}
                      >
                        <span className="continuebtn-text-2" >View All Earnings</span>
                      </button>
                    </div>
                    {/* <div>View Earnings</div> */}
                  </div>
                </>
              }
              <div className='row mt-4'>
                <div className='title w-auto'>Booking for Today</div>

              </div>


              {dashboard && dashboard?.todaysBooking ? (
                <div className='booking-inner-style p-3 mt-3'>
                  <div className='d-flex justify-content-between align-items-center w-100'>
                    <div className='d-flex flex-column flex-grow-1 gap-1'>
                      <span className='user-details'>{dashboard?.todaysBooking?.member?.first_name} {dashboard?.todaysBooking?.member?.last_name}</span>
                      {/* <div className='d-flex gap-1 align-items-center'>
                        <span className='user-common'>29 years</span>
                        <span className='vertical-border'></span>
                        <span className='user-common'>Female</span>
                      </div> */}
                      <span className='user-address'>{dashboard?.todaysBooking?.member?.address}</span>
                    </div>


                    {dashboard?.todaysBooking?.status === "assigned" ? (
                      <div className="slot-progressbar-conatiner p-1">
                        <span className="slot-progressbar">In Progress</span>
                      </div>
                    ) : dashboard?.todaysBooking?.status === "completed" ? (
                      <div className="slot-Completed-conatiner p-1">
                        <span className="slot-complete-progressbar">Completed</span>
                      </div>
                    ) : (
                      <div className="slot-Onway-conatiner p-1">
                        <span className="slot-Onway-progressbar">Ongoing</span>
                      </div>
                    )}

                  </div>

                  <div className="schedule-info d-flex align-items-center p-3 mt-3">
                    <div className="schedule-details d-flex flex-column w-100">
                      <span className="text">Schedule</span>
                      <div className="d-flex justify-content-between mt-1 gap-1">
                        <div className="d-flex flex-column">
                          <span className="time">
                            {dashboard.todaysBooking.date
                              ? moment(dashboard?.todaysBooking?.date).format("DD MMMM YYYY, ddd")
                              : ""}
                          </span>

                          <span className="date">
                            {dashboard.todaysBooking.fromTime
                              ? `${moment(dashboard?.todaysBooking?.fromTime, "HH:mm:ss").format("hh:mm A")} - ${moment(dashboard?.todaysBooking?.toTime, "HH:mm:ss").format("hh:mm A")}`
                              : ""}
                          </span>

                        </div>
                        <div>
                          <Link
                            to={`/appointmentdetail/${dashboard?.todaysBooking?._id}`}
                            style={{ textDecoration: 'none' }}
                          >
                            <span className="btn-text">View Now</span>
                          </Link>
                          {/* <Link
                            to={`/appointmentdetail/${dashboard?.todaysBooking?._id}`}
                            style={{ textDecoration: 'none' }}
                          >
                            <button className="view-btn">
                              <span className="btn-text">View Now</span>
                            </button>
                          </Link> */}

                        </div>
                      </div>

                    </div>

                  </div>
                  <div className='row w-100 m-auto mt-2'>
                    <div className='wa-box' onClick={() => handleWhatsAppClick('+91' + dashboard?.todaysBooking?.member?.phone_number)}>
                      <FaWhatsapp FaPlay size={"17px"} color='#25D366' style={{ width: 'auto' }} />
                      <span>Whatsapp</span>
                    </div>
                    <div className='wa-box-2' onClick={() => window.location.href = `tel:+91${dashboard?.todaysBooking?.member?.phone_number}`}>
                      <FaPhoneAlt FaPlay size={"17px"} color='#fff' style={{ width: 'auto' }} />
                      <span>Call</span>
                    </div>
                  </div>
                </div>
              ) :
                <>
                  <div className="booking-inner-error p-3 mt-4">
                    <div className="w-100 h-100 d-flex align-items-center justify-content-center">
                      <span className="not-available">Today booking not available</span>
                    </div>
                  </div>


                </>
              }

            </div>
            {/* close Booking info */}


            {/* Past Bookings */}
            <div className="booking-today-info mt-4">
              {dashboard && dashboard.pastBooking ? (
                <>
                  <Link to={`/appointmentdetail/${encodeURIComponent(dashboard?.pastBooking?._id)}`}>
                    <div className="d-flex justify-content-between">
                      <span className="title" style={{ textDecoration: 'none' }}>Past Bookings</span>
                      <Link to="/pastbooking" style={{ textDecoration: "none" }}>
                        <span className="view-all">View All</span>
                      </Link>
                    </div>

                    <div className="inner-style mt-3 mb-4">
                      <div className="d-flex align-items-center" style={{ padding: "12px" }}>
                        <span className="upcoming-schedule d-flex gap-1">
                          {
                            dashboard?.pastBooking?.date
                              ? <span>{moment(dashboard?.pastBooking?.date).format("DD MMM")}</span>
                              : ""
                          }
                          {
                            dashboard?.pastBooking?.fromTime
                              ? <span>{`${moment(dashboard?.pastBooking?.fromTime, "HH:mm:ss").format("hh:mm A")} - ${moment(dashboard?.pastBooking?.toTime, "HH:mm:ss").format("hh:mm A")}`}</span>
                              : ""
                          }
                        </span>

                      </div>
                      <div className="" style={{ borderBottom: "1.5px dashed #BEBEBE" }}></div>
                      <div className='p-3'>
                        <div className="d-flex gap-5 align-items-center w-100">
                          <div className="d-flex flex-column flex-grow-1 gap-1">
                            <span className="user-details">{dashboard?.pastBooking?.member?.first_name} {dashboard?.pastBooking?.member?.last_name}</span>
                            <span className="user-address">
                              {dashboard?.pastBooking?.member?.address}
                            </span>
                          </div>

                          {dashboard?.pastBooking?.status === "assigned" ? (
                            <div className="progress-status text-center flex-shrink-0">
                              <span className="status-text">In Progress</span>
                            </div>
                          ) : (
                            <div className="progress-status-completed text-center flex-shrink-0 p-1">
                              <span className="status-text">Completed</span>
                            </div>
                          )}
                        </div>

                        <div className="schedule-details-container d-flex flex-column p-3 mt-3">
                          <span className="booking-id d-flex ">
                            Booking ID - {dashboard?.pastBooking?.booking?.booking_number}
                          </span>
                          <div className="Session-details d-flex flex-sm-row gap-5 gap-md-5 justify-content-md-between w-100 mt-2">
                            <div>
                              <span className="text">Session Time</span>
                              <div className="d-flex justify-content-between gap-1">
                                <span className="date">
                                  {dashboard?.pastBooking?.fromTime
                                    ? `${moment(dashboard.pastBooking.fromTime, "HH:mm:ss").format("hh:mm A")} - ${moment(dashboard.pastBooking.toTime, "HH:mm:ss").format("hh:mm A")}`
                                    : ""}
                                </span>
                              </div>
                            </div>
                            <div>
                              <span className="text">Service</span>
                              <div className="d-flex justify-content-between">
                                <span className="date text-capitalize">{dashboard?.pastBooking?.interest?.name}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                    </div>
                  </Link>

                </>
              ) : (
                <>
                  <div className="">
                    <span className="title">Past Bookings</span>
                  </div>
                  <div className="booking-inner-error p-3 mt-4">
                    <div className="w-100 h-100 d-flex align-items-center justify-content-center">
                      <span className="not-available">Past booking not available</span>
                    </div>
                  </div>
                </>

              )}
            </div>

            {/* close Past Bookings */}


            {/* Past Bookings */}
            <div className='booking-today-info mt-4'>

              {dashboard && dashboard?.upcomingBooking ? (
                <>
                  <div className='d-flex justify-content-between'>
                    <span className='title'>Upcoming Bookings</span>
                    <Link to="/upcomingbooking" style={{ textDecoration: "none" }}>
                      <span className='view-all'>View All</span>
                    </Link>

                  </div>
                  <div className="inner-style mt-3 mb-4">
                    <div className="d-flex align-items-center" style={{ padding: "12px" }}>
                      <span className="upcoming-schedule d-flex gap-1">
                        {
                          dashboard?.upcomingBooking?.date
                            ? <span>{moment(dashboard?.upcomingBooking?.date).format("DD MMM")}</span>
                            : ""
                        }
                        {
                          dashboard?.upcomingBooking?.fromTime
                            ? <span>{`${moment(dashboard?.upcomingBooking?.fromTime, "HH:mm:ss").format("hh:mm A")} - ${moment(dashboard?.upcomingBooking?.toTime, "HH:mm:ss").format("hh:mm A")}`}</span>
                            : ""
                        }
                      </span>

                    </div>
                    <div className="" style={{ borderBottom: "1.5px dashed #BEBEBE" }}></div>

                    <div className="p-3">
                      <div className="d-flex justify-content-between align-items-center w-100">
                        <div className="d-flex flex-column flex-grow-1 gap-1">
                          <span className="user-details">{dashboard?.upcomingBooking?.member?.first_name} {dashboard?.upcomingBooking?.member?.last_name}</span>
                          {/* <div className="d-flex gap-1 align-items-center">
                          <span className="user-common">26 years</span>
                          <span className="vertical-border"></span>
                          <span className="user-common">Male</span>
                        </div> */}
                          <span className="user-address">{dashboard?.upcomingBooking?.member?.address}</span>
                        </div>
                      </div>
                      <div className="schedule-info d-flex align-items-center p-3 mt-3">
                        <div className="schedule-details d-flex flex-column w-100">
                          <span className="text">Schedule</span>
                          <div className="d-flex justify-content-between mt-1 gap-1">
                            <div className="d-flex flex-column">
                              <span className="time">
                                {dashboard.upcomingBooking.date
                                  ? moment(dashboard?.upcomingBooking?.date).format("DD MMMM YYYY, ddd")
                                  : ""}
                              </span>

                              <span className="date">
                                {dashboard.upcomingBooking.fromTime
                                  ? `${moment(dashboard?.upcomingBooking?.fromTime, "HH:mm:ss").format("hh:mm A")} - ${moment(dashboard?.upcomingBooking?.toTime, "HH:mm:ss").format("hh:mm A")}`
                                  : ""}
                              </span>

                            </div>
                            <div>
                              <Link
                                to={`/appointmentdetail/${dashboard?.upcomingBooking?._id}`}
                                style={{ textDecoration: 'none' }}
                              >
                                <span className="btn-text">View Now</span>
                              </Link>
                              {/* <Link
                            to={`/appointmentdetail/${dashboard?.todaysBooking?._id}`}
                            style={{ textDecoration: 'none' }}
                          >
                            <button className="view-btn">
                              <span className="btn-text">View Now</span>
                            </button>
                          </Link> */}

                            </div>
                          </div>

                        </div>

                      </div>
                      <div className='row w-100 m-auto mt-2'>
                        <div className='wa-box' onClick={() => handleWhatsAppClick('+91' + dashboard?.upcomingBooking?.member?.phone_number)}>
                          <FaWhatsapp FaPlay size={"17px"} color='#25D366' style={{ width: 'auto' }} />
                          <span>Whatsapp</span>
                        </div>
                        <div className='wa-box-2' onClick={() => window.location.href = `tel:+91${dashboard?.upcomingBooking?.member?.phone_number}`}>
                          <FaPhoneAlt FaPlay size={"17px"} color='#fff' style={{ width: 'auto' }} />
                          <span>Call</span>
                        </div>
                      </div>
                      {/* <div className="w-100 mt-3">
                        <Link to={`/appointmentdetail/${dashboard?.upcomingBooking?._id}`} style={{ textDecoration: 'none' }}>
                          <button className="view-now w-100">
                            <span className="btn-text">View Now</span>
                          </button>
                        </Link>

                      </div> */}
                    </div>
                  </div>
                </>

              ) :
                <>
                  <div className="">
                    <span className="title">Upcoming Bookings</span>
                  </div>
                  <div className="booking-inner-error p-3 mt-4">
                    <div className="w-100 h-100 d-flex align-items-center justify-content-center">
                      <span className="not-available">Upcoming booking not available</span>
                    </div>
                  </div>
                </>

              }

            </div>

            {/* close Past Bookings */}


          </div>
        </div>
      </div >
    </>

  )
}

const mapDispatchToProps = {
}
const mapStateToProps = (state) => {
  return {
    userdata: state.userSession?.sessionData,
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(Booking);